/**
 * Created by Ivan on 07.07.2026
 */

const StickersCollectionWindow = Prefab.createWindow("stickers_collection_window", "stickers_collection_window_prefab_json", {
    bundles: (collection) => [SeasonCollectionsHelper.getCollectionBundleName(collection.index, collection.season)]
});
